[
  "Pick up your badge",
  "Have your breakfast",
  "Attend the really cool talks by Kat Holmes",
  "Finish the Camp Design quests!",
  "Take part in the Design Systems Conversations Hour!",
  "Visit the conversation design booth",
  "Spin the color wheel",
  "Win that Astro Plushy",
  "Attend the breakout session about Kinetics System",
  "Get more coffee",
  "Attend keynote speech",
  "Participate in hands-on workshops",
  "Attend Ask Me Anything #DreamDesigner with Adam Doti",
  "Learn about new Salesforce products and features",
  "Network with other attendees",
  "Attend Enhance UI/UX with Kinetics and Design Systems with Pavithra Ramamurthy and Doug Molidor",
  "Explore the expo hall",
  "Rock out with Fallout Boy",
  "Attend breakout sessions",
  "Join a developer community meetup",
  "Attend Ask Me Anything: Designing with Customers with Jose Rafael Jimenez",
  "Get certified in Salesforce technologies",
  "Meet with Salesforce partners and sponsors",
  "Attend the Developer Theater sessions",
  "Participate in the Trailblazer Community Meetup",
  "Join the Salesforce User Group meeting",
  "Attend Design Great Products for the Greatest Number of People with Kat Holmes",
  "Learn about the latest trends in cloud computing",
  "Attend the Customer Success Expo sessions",
  "Get hands-on experience with Salesforce technologies",
  "Attend the Customer Success Keynote speech",
  "Participate in the Einstein Analytics workshop",
  "Learn about Salesforce's AI capabilities",
  "Join the Lightning Experience workshop",
  "Meet with Salesforce MVPs and experts",
  "Learn about AppExchange solutions and integrations",
  "Attend the Nonprofit Cloud Keynote speech",
  "Participate in the Nonprofit Cloud workshop",
  "Learn about ethical AI practices and policies"
]